import React from 'react';
import { ROUTE_KEYS } from 'utils/constants';
import AuthRoute from './AuthRoute';
import UnauthRoute from './UnauthRoute';
import Login from 'pages/auth/login';
import Dashboard from 'pages/dashboard';
import { Navigate, RouteObject, createBrowserRouter } from 'react-router-dom';
import GetStarted from 'pages/get-started/get-started-home';
import People from 'pages/people';
import Orders from 'pages/orders';
import Events from 'pages/events';
import DashboardLayout from 'layouts/dashboard.layout';
import App from 'pages/app';
import Auth from 'pages/auth';
import GetStartedLayout from 'layouts/get-started.layout';
import AddYourTeam from 'pages/get-started/add-your-team';
import AddBrand from 'pages/get-started/add-brand';
import AssignAdmin from 'pages/get-started/assign-admin';
import AddDepartment from 'pages/get-started/add-department';
import Profile from 'pages/profile';
import EditProfile from 'pages/edit-profile';
import EventDetails from 'pages/events/event-details';
import AddYourGuests from 'pages/events/event-details/add-your-guests';
import EventDetailsLayout from 'layouts/event-details.layout';
import Topupwallet from 'pages/events/event-details/top-up-wallet';
import ForgotPassword from 'pages/auth/forgot-password';
import AuthenticationLayout from 'layouts/auth.layout';
import CreatePassword from 'pages/auth/create-password';
import CreateAPassword from 'pages/auth/lets-get-started/create-password';
import PersonalDetails from 'pages/auth/lets-get-started';
import CompanyDetails from 'pages/auth/lets-get-started/company-details';
import VerifyAccount from 'pages/auth/lets-get-started/verify-account';
import ViewEventDetails from 'pages/events/view-event-details';
import GetStartedActionsLayout from 'layouts/get-started-actions.layout';
import GiftMembers from 'pages/gift-members';
import GiftMembersConfirm from 'pages/gift-members/gift-members-confirm';
import GiftMembersLayout from 'layouts/gift-members.layout';
import VerificationPending from 'pages/verification-pending';
import GetStartedTopupwallet from 'pages/get-started/topup-wallet';
import Payment from 'pages/payment';
import ResetPassword from 'pages/auth/reset-password';
import ConfirmYourMail from 'pages/auth/confirm-your-mail';
import AddMembers from 'pages/people/add-member';
import MonthlyInsight from 'pages/dashboard/insights/monthly-insight';
import GiftBulkMembers from 'pages/people/people-table-bulk-actions/gift-bulk-members';
import CreateNewPassword from 'pages/profile/manage-profile-password/create-new-password';
import ManageProfilePassword from 'pages/profile/manage-profile-password';
import ChangeEmail from 'pages/profile/change-email';
import NewEmail from 'pages/profile/change-email/new-email';
import VerifyEmail from 'pages/profile/change-email/verify-email';
import LetsGetStartedLayout from 'layouts/lets-get-started.layout';
import Home from 'pages/home';
import RoleAccepted from 'pages/role-accepted';
import VerifyNewAccountEmail from 'pages/verify-new-account-email';
import NeutralRoute from './NeutralRoute';
import Brand from 'pages/orders/restaurant';
import OrdersLayout from 'layouts/orders.layout';
import Checkout from 'pages/checkout';
import OrderDetails from 'pages/orders/order-details';
import SingleMeal from 'pages/orders/single-meal';
import BrandsDisplay from 'pages/orders/restaurants';
import GroupBasket from 'pages/orders/basket/group';
import BulkBasket from 'pages/orders/basket/bulk';
import Basket from 'pages/orders/basket';
import SupportPage from 'pages/support';
import FaqPage from 'pages/support/faq';
import BatchedOrdersBrands from 'pages/orders/batched-orders-brands';
import AddBranchAddresses from 'pages/get-started/add-branch-addresses';
import SetOperatingDays from 'pages/get-started/set-operating-days';
import BatchBasket from 'pages/orders/basket/batch';

const REGISTER_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <PersonalDetails />
  },
  {
    path: ROUTE_KEYS.COMPANY_DETAILS,
    element: <CompanyDetails />
  },
  {
    path: ROUTE_KEYS.CREATE_PASSWORD,
    element: <CreateAPassword />
  },
  {
    path: ROUTE_KEYS.VERIFY_ACCOUNT,
    element: <VerifyAccount />
  }
];

const EVENT_DETAILS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <EventDetails />
  },
  {
    path: ROUTE_KEYS.TOP_UP_WALLET,
    element: <Topupwallet />
  },
  {
    path: ROUTE_KEYS.ADD_YOUR_GUESTS,
    element: <AddYourGuests />
  }
];

const GET_STARTED_ACTION_ROUTES: RouteObject[] = [
  {
    path: ROUTE_KEYS.TOP_UP_WALLET,
    element: <GetStartedTopupwallet />
  },
  {
    path: ROUTE_KEYS.ADD_YOUR_TEAM,
    element: <AddYourTeam />
  },
  {
    path: ROUTE_KEYS.ADD_BRAND,
    element: <AddBrand />
  },
  {
    path: ROUTE_KEYS.ASSIGN_ADMIN,
    element: <AssignAdmin />
  },
  {
    path: ROUTE_KEYS.ADD_DEPARTMENT,
    element: <AddDepartment />
  },
  {
    path: ROUTE_KEYS.ADD_BRANCH_ADDRESSES,
    element: <AddBranchAddresses />
  },
  {
    path: ROUTE_KEYS.SET_OPERATING_DAYS,
    element: <SetOperatingDays />
  }
];
const GET_STARTED_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <GetStarted />
  },
  {
    path: ROUTE_KEYS.GET_STARTED_ACTION,
    element: <GetStartedActionsLayout />,
    children: GET_STARTED_ACTION_ROUTES
  }
];

const NEUTRAL_ROUTES: RouteObject[] = [
  {
    path: ROUTE_KEYS.VERIFY_EMAIL,
    element: <VerifyEmail />
  }
];

const AUTH_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Auth />
  },
  {
    path: ROUTE_KEYS.LOGIN,
    element: <Login />
  },
  {
    path: ROUTE_KEYS.CONFIRM_MAIL,
    element: <ConfirmYourMail />
  },
  {
    path: ROUTE_KEYS.FORGOT_PASSWORD,
    element: <ForgotPassword />
  },
  {
    path: ROUTE_KEYS.RESET_PASSWORD,
    element: <ResetPassword />
  },
  {
    path: ROUTE_KEYS.CREATE_PASSWORD,
    element: <CreatePassword />
  },
  {
    path: ROUTE_KEYS.REGISTER,
    element: <LetsGetStartedLayout />,
    children: REGISTER_ROUTES
  }
];
const GIFT_MEMBERS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <GiftMembers />
  },
  {
    path: ROUTE_KEYS.GIFT_MEMBERS_CONFIRM,
    element: <GiftMembersConfirm />
  }
];

const ORDERS_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <Orders />
  },
  {
    path: ROUTE_KEYS.RESTAURANTS,
    element: <BrandsDisplay />
  },
  {
    path: ROUTE_KEYS.CHECKOUT,
    element: <Checkout />
  },

  {
    path: ROUTE_KEYS.RESTAURANT,
    element: <Brand />
  },
  {
    path: ROUTE_KEYS.MEAL,
    element: <SingleMeal />
  },
  {
    path: ROUTE_KEYS.BASKET,
    element: <Basket />,
    children: [
      { path: ROUTE_KEYS.GROUP_BASKET, element: <GroupBasket /> },
      { path: ROUTE_KEYS.BULK_BASKET, element: <BulkBasket /> },
      { path: ROUTE_KEYS.BATCH_BASKET, element: <BatchBasket /> }
    ]
  },
  {
    path: ROUTE_KEYS.ORDER_DETAILS,
    element: <OrderDetails />
  },
  {
    path: ROUTE_KEYS.BATCHED_ORDERS_BRANDS,
    element: <BatchedOrdersBrands />
  }
];

const APP_ROUTES: RouteObject[] = [
  {
    index: true,
    element: <App />
  },
  {
    path: ROUTE_KEYS.GET_STARTED,
    element: <GetStartedLayout />,
    children: GET_STARTED_ROUTES
  },
  {
    path: ROUTE_KEYS.HOME,
    element: <Home />
  },
  {
    path: ROUTE_KEYS.DASHBOARD,
    element: <Dashboard />
  },
  {
    path: ROUTE_KEYS.PEOPLE,
    element: <People />
  },
  {
    path: ROUTE_KEYS.EVENTS,
    element: <Events />
  },
  {
    path: ROUTE_KEYS.PAYMENT,
    element: <Payment />
  },
  {
    path: ROUTE_KEYS.MONTHLY_INSIGHT,
    element: <MonthlyInsight />
  },
  {
    path: ROUTE_KEYS.EVENTS_DETAILS,
    element: <EventDetailsLayout />,
    children: EVENT_DETAILS_ROUTES
  },
  {
    path: ROUTE_KEYS.VIEW_EVENTS_DETAILS,
    element: <ViewEventDetails />
  },
  {
    path: ROUTE_KEYS.PROFILE,
    element: <Profile />
  },
  {
    path: ROUTE_KEYS.MANAGE_PROFILE_PASSWORD,
    element: <ManageProfilePassword />
  },
  {
    path: ROUTE_KEYS.CHANGE_EMAIL,
    element: <ChangeEmail />
  },
  {
    path: ROUTE_KEYS.NEW_EMAIL,
    element: <NewEmail />
  },
  {
    path: ROUTE_KEYS.CREATE_NEW_PASSWORD,
    element: <CreateNewPassword />
  },
  {
    path: ROUTE_KEYS.EDIT_PROFILE,
    element: <EditProfile />
  },

  {
    path: ROUTE_KEYS.GIFT_MEMBERS,
    element: <GiftMembersLayout />,
    children: GIFT_MEMBERS_ROUTES
  },
  {
    path: ROUTE_KEYS.ADD_PEOPLE,
    element: <AddMembers />
  },
  {
    path: ROUTE_KEYS.GIFT_BULK_MEMBERS,
    element: <GiftBulkMembers />
  },
  {
    path: ROUTE_KEYS.ORDERS,
    element: <OrdersLayout />,
    children: ORDERS_ROUTES
  },
  { path: ROUTE_KEYS.SUPPORT, element: <SupportPage /> },
  { path: ROUTE_KEYS.FAQ, element: <FaqPage /> }
];

const ALL_ROUTES: RouteObject[] = [
  {
    path: ROUTE_KEYS.AUTH,
    element: (
      <UnauthRoute>
        <AuthenticationLayout />
      </UnauthRoute>
    ),
    children: AUTH_ROUTES
  },
  {
    path: ROUTE_KEYS.APP,
    element: (
      <AuthRoute>
        <DashboardLayout />
      </AuthRoute>
    ),
    children: APP_ROUTES
  },
  {
    path: ROUTE_KEYS.VERIFICATION_PENDING,
    element: (
      <AuthRoute>
        <VerificationPending />
      </AuthRoute>
    )
  },
  {
    path: ROUTE_KEYS.VERIFY_NEW_ACCOUNT_EMAIL,
    element: (
      <NeutralRoute>
        <VerifyNewAccountEmail />
      </NeutralRoute>
    )
  },
  {
    path: ROUTE_KEYS.ROLE_ACCEPTED,
    element: (
      <NeutralRoute>
        <RoleAccepted />
      </NeutralRoute>
    )
  },
  {
    path: ROUTE_KEYS.AUTH,
    element: (
      <NeutralRoute>
        <AuthenticationLayout />
      </NeutralRoute>
    ),
    children: NEUTRAL_ROUTES
  },
  {
    path: '*',
    element: <Navigate to={ROUTE_KEYS.DASHBOARD} />
  }
];

export default createBrowserRouter(ALL_ROUTES);
